import type { AuthHeaders } from '../client'
import { request } from '../client'
import type { Player, Team } from '../types'

export function listTeams(auth: AuthHeaders): Promise<Team[]> {
  return request<Team[]>('/teams', { auth })
}

export function listPlayers(
  auth: AuthHeaders,
  teamId: number,
): Promise<Player[]> {
  return request<Player[]>('/players', {
    query: { team_id: teamId },
    auth,
  })
}
